var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoDeleteBtn',{class:{ invisible: _vm.disabled },attrs:{"message":_vm.__t(
      _vm.asset.swComplianceAlert
        ? 'confirm_turoff_installation_notification'
        : 'confirm_turnon_installation_notification'
    )},on:{"confirm":_vm.handleUpdate},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('a',{class:{
        'text-neutral': _vm.asset.swComplianceAlert,
        'text-secondary-red': !_vm.asset.swComplianceAlert,
        'mx-2': true,
      },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('trigger')}}},[(_vm.asset.swComplianceAlert)?_c('MIcon',{attrs:{"name":"bell","size":"lg"}}):_c('MIcon',{attrs:{"name":"bell-slash","size":"lg"}})],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }